/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(function() {
  // Intercept window.location.assign()
  const originalAssign = window.location.assign;
  window.location.assign = function(url) {
    const modifiedUrl = interceptRedirect(url);
    originalAssign.call(window.location, modifiedUrl);
  };

  // Intercept window.location.replace()
  const originalReplace = window.location.replace;
  window.location.replace = function(url) {
    const modifiedUrl = interceptRedirect(url);
    originalReplace.call(window.location, modifiedUrl);
  };

  // Intercept anchor <a> clicks
  document.addEventListener('click', function(e) {
   
    const link = e.target.getAttribute('aria-label') === 'Adding...';
    if (link && e.target.tagName === 'BUTTON') {
      const modified = interceptRedirect();
      if (modified) {
        e.preventDefault();
        window.location.assign(modified);
      }
    }
  });

  function interceptRedirect() {
    const marketPrefix = Shopify?.routes?.root || '/';
    return marketPrefix.replace(/\/+$/, '') + '/cart';
  }
})();

